export const emailValidationPatterns =
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const aadharRegex = /^\d{12}$/;
export const onlyNumberRegex = /^\d*$/;
export const onlyNumberRegexwithEightDigits = /^\d{0,8}$/;
export const numberWithDotNumberRegex = /^\d*\.?\d*$/;
export const numberWithDecimalRegex = /^\d*\.?\d*$/;
export const numberWithDecimalRegexWithEight =
  /^(?:\d{1,8}|\d{1,7}\.\d{0,1}|\d{1,6}\.\d{2})$/;
export const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const mustbe12Digits = /^\d{12}$/;
export const pfNumberRegex = /^[A-Z]{5}\d+$/;
export const specialCharacterRestrict = /^[a-zA-Z0-9 -]*$/; // allow space & -
export const specialCharRes = /^[a-zA-Z0-9._ :-]*$/;
export const specialCharacterRest = /^[a-zA-Z0-9]*$/;
export const rgxWithDot = /^[0-9]*\.?[0-9]*$/;
export const rgxWithDotFactor = /^([0-9]{1,2})(\.[0-9]{0,2})?$/;
export const rgxWithDotFactorOneDigit = /^([0-9]{1})(\.[0-9]{0,2})?$/;
export const ifscCodePatterns = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const atleastOneCharacter = /^\d*[a-zA-Z][a-zA-Z0-9]*$/;
export const atleastOneCharacterWithSpace = /^(?=.*[a-zA-Z]).*$/;
export const atleastOneSpecialCharaters = /^(?=.*[!@#$%^&*(),.?":{}|<>]).*$/;
export const lessthenHundred = /^(?:[1-9]?\d|100)$/;
export const dotFloatTwoAndNegative = /^-?\d*(\.\d{0,2})?$/; // 2 digits after . allow negative value
// export const pfNumberRegex = /\b[A-Za-z0-9]{22}\b/g;
export const threeDigitTwoDecimalPattern = /^\d{1,3}(\.\d{0,2})?$/;
export const fourDigitTwoDecimalPattern = /^\d{1,4}(\.\d{0,2})?$/;
export const percentagePattern = /^(100(\.0{0,2})?|(\d{1,2})(\.\d{0,2})?)$/;
